export default "<div>\n  Body\n</div>"